import type { Locale } from "@/i18n/dictionaries";

type OptionLabels = {
  "zh-CN": string;
  "en-US": string;
};

const optionLabelMap: Record<string, OptionLabels> = {
  "\u0039\u0032\u0035\u94f6": { "zh-CN": "\u0039\u0032\u0035\u94f6", "en-US": "925 Silver" },
  "\u0039\u0032\u0035 \u94f6": { "zh-CN": "\u0039\u0032\u0035\u94f6", "en-US": "925 Silver" },
  "925 Silver": { "zh-CN": "\u0039\u0032\u0035\u94f6", "en-US": "925 Silver" },
  "\u0031\u0038\u004b\u767d\u91d1": { "zh-CN": "\u0031\u0038\u004b\u767d\u91d1", "en-US": "18K White Gold" },
  "\u0031\u0038\u004b \u767d\u91d1": { "zh-CN": "\u0031\u0038\u004b\u767d\u91d1", "en-US": "18K White Gold" },
  "18K White Gold": { "zh-CN": "\u0031\u0038\u004b\u767d\u91d1", "en-US": "18K White Gold" },
  "\u0031\u0038\u004b\u9ec4\u91d1": { "zh-CN": "\u0031\u0038\u004b\u9ec4\u91d1", "en-US": "18K Yellow Gold" },
  "\u0031\u0038\u004b \u9ec4\u91d1": { "zh-CN": "\u0031\u0038\u004b\u9ec4\u91d1", "en-US": "18K Yellow Gold" },
  "18K Yellow Gold": { "zh-CN": "\u0031\u0038\u004b\u9ec4\u91d1", "en-US": "18K Yellow Gold" },
  "\u0031\u0038\u004b\u73ab\u7470\u91d1": { "zh-CN": "\u0031\u0038\u004b\u73ab\u7470\u91d1", "en-US": "18K Rose Gold" },
  "\u0031\u0038\u004b \u73ab\u7470\u91d1": { "zh-CN": "\u0031\u0038\u004b\u73ab\u7470\u91d1", "en-US": "18K Rose Gold" },
  "18K Rose Gold": { "zh-CN": "\u0031\u0038\u004b\u73ab\u7470\u91d1", "en-US": "18K Rose Gold" },
  "\u9ec4\u94dc": { "zh-CN": "\u9ec4\u94dc", "en-US": "Brass" },
  "Brass": { "zh-CN": "\u9ec4\u94dc", "en-US": "Brass" },
  "\u629b\u5149": { "zh-CN": "\u629b\u5149", "en-US": "Polished" },
  "Polished": { "zh-CN": "\u629b\u5149", "en-US": "Polished" },
  "\u7c97\u629b": { "zh-CN": "\u7c97\u629b", "en-US": "Rough Polished" },
  "\u62c9\u4e1d": { "zh-CN": "\u62c9\u4e1d", "en-US": "Brushed" },
  "Brushed": { "zh-CN": "\u62c9\u4e1d", "en-US": "Brushed" },
  "\u55b7\u7802": { "zh-CN": "\u55b7\u7802", "en-US": "Sandblasted" },
  "Sandblasted": { "zh-CN": "\u55b7\u7802", "en-US": "Sandblasted" },
  "\u78e8\u7802": { "zh-CN": "\u78e8\u7802", "en-US": "Matte Finish" },
  "\u9593\u5f35": { "zh-CN": "\u9593\u5f35", "en-US": "Special Finish" },
  "\u7535\u9540": { "zh-CN": "\u7535\u9540", "en-US": "Plated" },
  "\u7535\u9540\u004b\u9ec4": { "zh-CN": "\u7535\u9540\u004b\u9ec4", "en-US": "Yellow Gold Plated" },
  "\u7535\u9540\u9ec4\u004b": { "zh-CN": "\u7535\u9540\u9ec4\u004b", "en-US": "Yellow Gold Plated" },
  "\u9540\u9ec4\u004b\u91d1": { "zh-CN": "\u9540\u9ec4\u004b\u91d1", "en-US": "Yellow Gold Plated" },
  "Yellow Gold Plated": { "zh-CN": "\u7535\u9540\u004b\u9ec4", "en-US": "Yellow Gold Plated" },
  "\u7535\u9540\u004b\u7ea2": { "zh-CN": "\u7535\u9540\u004b\u7ea2", "en-US": "Rose Gold Plated" },
  "\u7535\u9540\u7ea2\u004b": { "zh-CN": "\u7535\u9540\u7ea2\u004b", "en-US": "Rose Gold Plated" },
  "\u9540\u73ab\u7470\u91d1": { "zh-CN": "\u9540\u73ab\u7470\u91d1", "en-US": "Rose Gold Plated" },
  "Rose Gold Plated": { "zh-CN": "\u7535\u9540\u004b\u7ea2", "en-US": "Rose Gold Plated" },
  "\u7535\u9540\u004b\u767d": { "zh-CN": "\u7535\u9540\u004b\u767d", "en-US": "White Gold Plated" },
  "\u7535\u9540\u767d\u004b": { "zh-CN": "\u7535\u9540\u767d\u004b", "en-US": "White Gold Plated" },
  "\u9540\u767d\u004b\u91d1": { "zh-CN": "\u9540\u767d\u004b\u91d1", "en-US": "White Gold Plated" },
  "White Gold Plated": { "zh-CN": "\u7535\u9540\u004b\u767d", "en-US": "White Gold Plated" },
  "\u7535\u9540\u004b\u9ed1": { "zh-CN": "\u7535\u9540\u004b\u9ed1", "en-US": "Black Plated" },
  "\u7535\u9540\u9ed1\u004b": { "zh-CN": "\u7535\u9540\u9ed1\u004b", "en-US": "Black Plated" },
  "\u7535\u9540\u9ed1\u8272": { "zh-CN": "\u7535\u9540\u9ed1\u8272", "en-US": "Black Plated" },
  "\u9540\u9ed1": { "zh-CN": "\u9540\u9ed1", "en-US": "Black Plated" },
  "Black Plated": { "zh-CN": "\u7535\u9540\u004b\u9ed1", "en-US": "Black Plated" }
};

function normalizeOptionLabel(label: string) {
  return label.replace(/\s+/g, " ").trim();
}

function containsHan(label: string) {
  return /[\u3400-\u9fff]/.test(label);
}

export function localizeProductOptionLabel(label: string | undefined, locale: Locale) {
  if (!label) {
    return "";
  }

  const normalized = normalizeOptionLabel(label);
  if (optionLabelMap[normalized]) {
    return optionLabelMap[normalized][locale];
  }

  if (normalized.includes("\u7535\u9540") || normalized.includes("\u934d")) {
    if (normalized.includes("\u9ec4") || normalized.includes("\u9ec3")) {
      return locale === "en-US" ? "Yellow Gold Plated" : "\u7535\u9540K\u9ec4";
    }
    if (normalized.includes("\u7ea2") || normalized.includes("\u7d05") || normalized.includes("\u73ab\u7470")) {
      return locale === "en-US" ? "Rose Gold Plated" : "\u7535\u9540K\u7ea2";
    }
    if (normalized.includes("\u767d")) {
      return locale === "en-US" ? "White Gold Plated" : "\u7535\u9540K\u767d";
    }
    if (normalized.includes("\u9ed1")) {
      return locale === "en-US" ? "Black Plated" : "\u7535\u9540K\u9ed1";
    }
  }

  if (locale === "en-US" && containsHan(normalized)) {
    return "Special Finish";
  }

  return optionLabelMap[normalized]?.[locale] || normalized;
}
